export class HttpParamsConstants {

    //Organisation Service Params
    static readonly ORG_NAME: string = "orgName";

    //Generic list params
    static readonly PAGE_NUMBER: string = "pageNumber";
    static readonly INITIAL_LOAD: string = "isInitialLoad";
}

export class HttpHeadersConstants {
    static readonly CONTENT_TYPE: string = "Content-Type";
    static readonly APP_JSON: string = "application/json";
}